// Module
var code = `<div class="row margin-bottom" data-bind="validationElement: bucket">
    <label class="control-label col-xs-12 col-sm-6 col-lg-4">
        Bucket <i class="required"></i> <small><i class="bucket-gcs-info icon-info text-info"></i></small>
    </label>
    <div class="col-xs-12 col-sm-6 col-lg-8">
        <input data-bind="textInput: bucket" type="text" class="form-control">
    </div>
</div>
<div class="row margin-bottom" data-bind="validationElement: remoteFolderName">
    <label class="control-label col-xs-12 col-sm-6 col-lg-4">Remote folder name</label>
    <div class="col-xs-12 col-sm-6 col-lg-8">
        <input data-bind="textInput: remoteFolderName" type="text" class="form-control">
    </div>
</div>
<div class="row margin-bottom" data-bind="validationElement: googleCredentialsJson">
    <label class="control-label col-xs-12 col-sm-6 col-lg-4">Google Credentials Json <i class="required"></i></label>
    <div class="col-xs-12 col-sm-6 col-lg-8">
        <textarea rows="9" data-bind="textInput: googleCredentialsJson, visible: credentialsVisible" class="form-control" placeholder='e.g.
{
    "type": "service_account",
    "project_id": "test-raven-237012",
    "private_key_id": "12345678123412341234123456789101",
    "private_key": "-----BEGIN PRIVATE KEY-----\\abCse=\\n-----END PRIVATE KEY-----\\n",
    "client_email": "raven@test-raven-237012-237012.iam.gserviceaccount.com",
    "client_id": "111390682349634407434",
    "auth_uri": "https://accounts.google.com/o/oauth2/auth",
    "token_uri": "https://oauth2.googleapis.com/token",
    "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
    "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/viewonly%40test-raven-237012.iam.gserviceaccount.com"
  }
        '></textarea>
        <button class="btn btn-default margin-right-xs" data-bind="click: toggleCredentials, visible: !credentialsVisible()" title="View credentials">
            <i class="icon-preview"></i> <span>Show credentials</span>
        </button>
        <button class="btn btn-info margin-right-xs" data-bind="click: toggleCredentials, visible: credentialsVisible" title="Hide credentials">
            <i class="icon-preview-off"></i> <span>Hide credentials</span>
        </button>
        
    </div>
</div>
`;
// Exports
export default code;